import {Input} from "react-materialize";
import React, {Component} from "react";

export class CheckedEmailInput extends Component {
    render(){
        return (
            <Input disabled={this.props.checked} {...this.props}/>
        );
    }
}
